/**
 * Matches a number or float with either dot or comma as a decimal separator. In many European countries comma is used as a separator for floating numbers.
 *  @example 123 123.1 0.123 .123 0.2
 */
export const numberDotCommaRegex = /^\d*\.?\d*$/;
